// DEROS: click-to-zoom for images in migrated blog articles.
//
// The viewer itself is assets/deros-lightbox.js (the site's one image viewer,
// shared with the showcase galleries), so an article picture opens with the
// same chrome as a gallery picture: dimmed page, plain close and arrows, the
// picture's alt text as its caption and "n of N" beside it.
//
// Prestige's own lightbox cannot be reused: `open-lightbox-button` merely
// dispatches a bubbling `lightbox:open` event, and the PhotoSwipe instance
// that listens for it lives inside `product-gallery`, which builds its slides
// from product media. Article images are not product media.
//
// The viewer is imported on demand, so a reader who never clicks an image
// never downloads PhotoSwipe.

import { openDerosLightbox } from "deros-lightbox";

const SELECTOR = ".prose .article-gallery img, .prose .article-image img";

const images = Array.from(document.querySelectorAll(SELECTOR));
if (images.length > 0) {
  // The distiller preserves each image's width and height attributes, which is
  // exactly what PhotoSwipe needs to size a slide before it loads. naturalWidth
  // covers the rare image that arrived without them.
  const slidesFor = () =>
    images.map((img) => ({
      src: img.currentSrc || img.src,
      width: Number(img.getAttribute("width")) || img.naturalWidth || 1600,
      height: Number(img.getAttribute("height")) || img.naturalHeight || 1200,
      alt: img.getAttribute("alt") || "",
      caption1: img.getAttribute("alt") || "",
      caption2: ""
    }));

  let opening = false;

  async function open(index) {
    if (opening) return;
    opening = true;
    try {
      await openDerosLightbox(slidesFor(), index);
    } catch (error) {
      // A failed viewer must never swallow the image. Leaving the page as-is is
      // the correct fallback: the picture is still visible inline.
      console.error("[deros] could not open the image viewer:", error);
    } finally {
      opening = false;
    }
  }

  images.forEach((img, index) => {
    // Set only now, so the zoom cursor appears only when clicking really works.
    img.setAttribute("data-lightbox", "");
    img.setAttribute("role", "button");
    img.setAttribute("tabindex", "0");

    img.addEventListener("click", () => open(index));
    img.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;
      event.preventDefault(); // Space would otherwise scroll the page
      open(index);
    });
  });
}
